import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/report/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/report/';

class ReportService {

  getAllTypeStates() {
    return axios.get(API_URL  + 'states/');
  }

  getAllDeepReportVisible() {
    return axios.get(API_URL);
  }

  updateReportState(reportId,state) {
    return axios.put(`${API_URL}${reportId}/state`,state);
  }

  getDownloadURL(reportId,filename) {
    return axios.get(`${API_URL}${reportId}/downloadURL/${filename}`);
  }

  download(url){
    return axios.get(url);
  }

  getUploadURL(reportId,filename) {
    return axios.get(`${API_URL}${reportId}/uploadURL/${filename}`);
  }

  upload(url,file){
    return axios.put(url,file);
  }

  getDeleteURL(reportId,filename) {
    return axios.get(`${API_URL}${reportId}/deleteURL/${filename}`);
  }

  delete(url){
    return axios.delete(url);
  }

  updateReportFilename(reportId,filename) {
    return axios.put(`${API_URL}${reportId}/filename/${filename}`,null);
  }

  read(reportId) {
    return axios.put(`${API_URL}${reportId}/read`,null);
  }

  getAllTypePetitions() {
    return axios.get(`${API_URL}petition-types`,null);
  }

  getReportDetail(id){
    return axios.get(`${API_URL}${id}`);
  }

  getReportMessages(id){
    return axios.get(`${API_URL}${id}/messages`);
  }

  postReportMessage(id,message){
    return axios.post(`${API_URL}${id}/messages`,message);
  }

  getNewMessages(id){
    return axios.get(`${API_URL}${id}/unread-messages`);
  }
}

export default new ReportService();
